import { useMemo } from "react";

// Default to light for SSR; Chakra detects system
// preference on client and sets cookie for future loads.
const DEFAULT_COLOR_MODE = "light";

const CHAKRA_COOKIE_COLOR_KEY = "chakra-ui-color-mode";

// Loader data is serialized into the document and is readable by browser
// JavaScript. Return only the non-sensitive Chakra preference instead of the
// request's complete Cookie header (which also contains the HttpOnly session).
export function getColorModeCookie(cookies = "") {
  const colorMode = getColorMode(cookies);
  return colorMode === "light" || colorMode === "dark"
    ? `${CHAKRA_COOKIE_COLOR_KEY}=${colorMode}`
    : "";
}

export function useColorMode(cookies = "") {
  // the client get the cookies from the document
  // because when we do a client routing, the loader can have stored an outdated value
  if (typeof document !== "undefined") {
    cookies = document.cookie;
  }

  // get and store the color mode from the cookies.
  // It'll update the cookies if there isn't any and we have set a default value
  let colorMode = useMemo(() => {
    let color = getColorMode(cookies);

    if (!color && DEFAULT_COLOR_MODE) {
      cookies += ` ${CHAKRA_COOKIE_COLOR_KEY}=${DEFAULT_COLOR_MODE}`;
      color = DEFAULT_COLOR_MODE;
    }

    return color;
  }, [cookies]);

  return { colorMode, cookies };
}

function getColorMode(cookies) {
  const match = cookies.match(
    new RegExp(`(^| )${CHAKRA_COOKIE_COLOR_KEY}=([^;]+)`),
  );
  return match == null ? void 0 : match[2];
}
